<template>
  <div class="modeDisplay">
    <h4>Pick Jacket Trim Color</h4>
    <component class="editing-component" :is="editingComponent"/>
    <div class="color-label__wrap">
      <div class="color-label">Base:</div>
      <b>{{ baseTrimsColor.title }}</b>
    </div>
    <div class="color-label__wrap" v-if="!!isPatternColors.isSecondaryTrimsColor">
      <div class="color-label">Stripes:</div>
      <b>{{ secondaryTrimsColor.title }}</b>
    </div>
    <div class="color-label__wrap" v-if="!!isPatternColors.isFinishTrimsColor">
      <div class="color-label">Thin Stripes:</div>
      <b>{{ finishTrimsColor.title }}</b>
    </div>
    <div class="modeDisplayBtn">
      <b-button variant="success" @click="onFinish">Finish</b-button>
    </div>
  </div>
</template>

<script>
import PatternA from '@/components/jacket/trims/trimPatterns/PatternA.vue';
import PatternB from '@/components/jacket/trims/trimPatterns/PatternB.vue';
import PatternC from '@/components/jacket/trims/trimPatterns/PatternC.vue';
import PatternD from '@/components/jacket/trims/trimPatterns/PatternD.vue';
import PatternE from '@/components/jacket/trims/trimPatterns/PatternE.vue';
import PatternF from '@/components/jacket/trims/trimPatterns/PatternF.vue';

export default {
  name: 'TrimModeDisplay',
  components: {
    PatternA,
    PatternB,
    PatternC,
    PatternD,
    PatternE,
    PatternF,
  },
  props: {
    editingComponent: String,
    isPatternColors: Object,
  },
  computed: {
    baseTrimsColor () {
      return this.$store.getters['design/getBaseTrimsColor'];
    },
    secondaryTrimsColor () {
      return this.$store.getters['design/getSecondaryTrimsColor'];
    },
    finishTrimsColor () {
      return this.$store.getters['design/getFinishTrimsColor'];
    },
  },
  methods: {
    onFinish () {
      this.$emit('patternEditModeOff');
    }
  },
};

</script>

<style scoped>
.modeDisplay {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  margin-left: 10px;
  padding: 10px;
}

.color-label__wrap {
  margin-bottom: 10px;
}

.editing-component {
  margin-bottom: 10px;
}

.modeDisplayBtn {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}
</style>
